import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/districts/form'
import { api, actionCreators } from 'store/modules/districts'

const metadata = {
  icon: 'flag',
  page: 'districts',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
